<template>
  <div>
    <div id="box" style="display: none;">
    </div>
    <!-- <div class="box"></div> -->
    <!-- 定部 -->
    <div class="header">
      <div class="header-l" @click="navto(1)">
        <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
      </div>
      <div id="btn" class="header-r" @click="addnav">
        <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
      </div>
    </div>
    <div class="top-img">
      <h3>域贝大数据平台</h3>
      <p>以自主研发的第三代瑶池数据仓库为数据存储核心，实现了数据汇集、治理、资产、分析、服务、应用等数据全流程全生命周期大数据平台。 </p>
      <div class=" button">
        <button class="addbtn" @click="openCallUs">联系我们</button>
      </div>

    </div>
    <div class="main-1">
      <h3>功能亮点</h3>
      <ul>
        <li>
          <img src="../../../assets/images/手机端/大数据 手机端/可视化(1)@2x.png" alt="">
          <p>可视化操控</p>
        </li>
        <li>
          <img src="../../../assets/images/手机端/大数据 手机端/文件共享@2x.png" alt="">
          <p>海量存储共享</p>
        </li>
        <li>
          <img src="../../../assets/images/手机端/大数据 手机端/搜索引擎(1)@2x.png" alt="">
          <p>强大搜索引擎</p>
        </li>
        <li>
          <img src="../../../assets/images/手机端/大数据 手机端/运维服务集成@2x.png" alt="">
          <p>资产化运维</p>
        </li>
        <li>
          <img src="../../../assets/images/手机端/大数据 手机端/场景化(1)@2x.png" alt="">
          <p>场景化应用</p>
        </li>
      </ul>
    </div>
    <div class="gojia">
      <h3>平台构架</h3>
      <img src="../../../assets/images/手机端/大数据 手机端/平台架构@2x.png" alt="">
    </div>
    <div class="jiazhi">
      <h3 class="cpjiazhi">竞争优势</h3>
      <ul>
        <li :class="{ listiscolor1: iscolor1 }" @click="clicklistcolor1">
          <div class="jiazhi_limg">
            <img src="../../../assets/images/手机端/大数据 手机端/创新的可视化操控@2x.png" alt="">
          </div>
          <div class="jiazhi_rtext">
            <h3>创新的可视化操控</h3>
            <p>海量、异构、全域的数据汇聚可视化操控，支持数据源一键接入</p>
          </div>
        </li>
        <li :class="{ listiscolor2: iscolor2 }" @click="clicklistcolor2">
          <div class="jiazhi_limg">
            <img src="../../../assets/images/手机端/大数据 手机端/安全高效的数据共享@2x.png" alt="">
          </div>
          <div class="jiazhi_rtext">
            <h3>安全高效的数据共享 </h3>
            <p>支持数据批量推拉、数据订阅等多种安全高效的数据共享方式</p>
          </div>
        </li>
        <li :class="{ listiscolor3: iscolor3 }" @click="clicklistcolor3">
          <div class="jiazhi_limg">
            <img src="../../../assets/images/手机端/大数据 手机端/优异的数据搜索能力@2x.png" alt="">
          </div>
          <div class="jiazhi_rtext">
            <h3>优异的数据搜索能力</h3>
            <p>基于全文搜索引擎，提供实时流处理和数据检索动力</p>
          </div>
        </li>
        <li :class="{ listiscolor4: iscolor4 }" @click="clicklistcolor4">
          <div class="jiazhi_limg">
            <img src="../../../assets/images/手机端/大数据 手机端/资产化的监控运维@2x.png" alt="">
          </div>
          <div class="jiazhi_rtext">
            <h3>资产化的监控运维</h3>
            <p>便捷的数据质量全生命周期实时监控，以资产管理模式来运维数据</p>
          </div>
        </li>
        <li :class="{ listiscolor5: iscolor5 }" @click="clicklistcolor5">
          <div class="jiazhi_limg">
            <img src="../../../assets/images/手机端/大数据 手机端/灵活的数据应用能力@2x.png" alt="">
          </div>
          <div class="jiazhi_rtext">
            <h3>灵活的数据应用能力</h3>
            <p>利用数据运算以及丰富的服务接口，赋能数据应用场景化需求</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="footer">
      <ul>
        <li @click="goyuzan">
          <p>玉瓒云校园</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu = !subMenu">
          <p>一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'visualizationpage' })">
          <p>产品详情</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'pricepage' })">
          <p>产品定价</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu2 = !subMenu2">
          <p>域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="goproductservice">
          <p>域贝证书宝</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="gointegratedpage">
          <p>域贝一体化</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="godate">
          <p>域贝大数据</p>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="logn">
        <img src="../../../assets/images/手机端/首页 手机端/logo.png" alt="">
      </div>
      <div class="dianhua">
        <p><img src="../../../assets/images/手机端/首页 手机端/电话(1).png" alt="">400-051-0806</p>
      </div>
      <div class="dizhi">
        <p><img src="../../../assets/images/手机端/首页 手机端/地址.png" alt="">浙江省温州市鹿城区车站大道11号高联大厦1608室</p>
      </div>
      <img @click="iswei" class="erweima" src="../../../assets/images/手机端/首页手机端/二维码.png" alt="">

      <div class="footer-bottom">
        <p>备案号：浙ICP备13031672</p>
      </div>
    </div>
    <div class="mask"></div>
    <div class="mask"></div>
    <div class="mask1"></div>
    <div class="erweima1">
      <!-- <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt=""> -->
    </div>
    <div class="ismask" @click.self="qiemask" v-show="ismask">
      <div class="isnav" v-show="isnav">
        <ul>
          <li @click="navto(1)">首页</li>
          <li @click="subMenu = !subMenu">域贝可视化<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>

          </li>
          <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
          <li v-if="subMenu" class="subLi" @click="navto(8)">定价</li>
          <li @click="navto(2)">域贝电子证书</li>
          <li @click="navto(3)">域贝大数据</li>
          <li @click="navto(4)">域贝一体化</li>
          <li @click="navto(5)">解决方案</li>
          <li @click="navto(6)">关于掌网</li>
        </ul>
      </div>
    </div>
    <div v-show="isweixiang" class="iserweima" @click.stop.self.prevent="isis">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>

    <div v-show="callUsDialog" :class="[callUsIndex === 0 ? 'callUs' : 'callUs_2']"
      @click.stop.self.prevent="closeCallUs">
      <div :class="[callUsIndex === 0 ? 'callUs_dialog' : 'callUs_dialog_2']">
        <div class="callUs_title">
          <img class="down" @click="closeCallUs" src="../../../assets/images/手机端/首页手机端/向右箭头备份5.png" alt="">
          <p>联系我们</p>
        </div>
        <div class="bottom_msg">
          <p>您的称呼</p>
          <input :value="name" placeholder="请输入您的称呼" />
          <p>手机号码</p>
          <input :value="phone" placeholder="请输入您的手机号码" />
          <button class="callUs_btn" @click="closeCallUs">提交</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      isnav: false,
      ismask: false,
      iscolor1: false,
      iscolor2: false,
      iscolor3: false,
      iscolor4: false,
      iscolor5: false,
      isweixiang: false,
      callUsDialog: false,
      callUsIndex: 0,
      name: '',
      phone: '',
      subMenu: false,
      subMenu2: false
    }
  },
  methods: {
    iswei() {
      this.isweixiang = true
    },
    isis() {
      this.isweixiang = false
    },
    openCallUs() {
      this.callUsIndex = 0
      this.callUsDialog = true
      this.$refs.callUs_dialog.animation = 'callUs 1s infinite;'
    },
    closeCallUs() {
      this.callUsIndex = 1
      setTimeout(() => {
        this.callUsDialog = false
      }, 500);
    },
    goproductservice() {
      this.$router.push({ path: 'hoproductservicepage' })
    },
    godate() {
      this.$router.push({ path: 'hodate' })
    },
    goyuzan() {
      window.location.href='http://www.yuzanyun.com'
    },
    gointegratedpage() {
      this.$router.push({ path: 'integratedpage' })
    },
    addnav() {
      this.ismask = !this.ismask
      this.isnav = !this.isnav
    },
    qiemask() {
      // console.log(111);
      this.ismask = false
      this.isnav = false
    },
    clicklistcolor1() {
      console.log(111);
      this.iscolor1 = true
      setTimeout(() => {
        this.iscolor1 = false
      }, 1000)
    },
    clicklistcolor2() {
      this.iscolor2 = true
      setTimeout(() => {
        this.iscolor2 = false
      }, 1000)
    },
    clicklistcolor3() {
      this.iscolor3 = true
      setTimeout(() => {
        this.iscolor3 = false
      }, 1000)
    },
    clicklistcolor4() {
      this.iscolor4 = true
      setTimeout(() => {
        this.iscolor4 = false
      }, 1000)
    },
    clicklistcolor5() {
      this.iscolor5 = true
      setTimeout(() => {
        this.iscolor5 = false
      }, 1000)
    },
    navto(n) {
      if (n == 1) {
        this.$router.push({ path: 'index' })
      } else if (n == 2) {
        this.$router.push({ path: 'hoproductservicepage' })
      } else if (n == 3) {
        this.ismask = false
        this.isnav = false

      } else if (n == 4) {
        this.$router.push({ path: 'integratedpage' })
      } else if (n == 5) {
        this.$router.push({ path: 'cooperationpage' })
      } else if (n == 6) {
        this.$router.push({ path: 'aboutpage' })
      } else if (n == 7) {
        this.$router.push({ path: 'visualizationpage' })
      } else if (n == 8) {
        this.$router.push({ path: 'pricepage' })
      } else if (n == 9) {
        window.location.href='http://www.yuzanyun.com'
      }
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

li {
  list-style: none;
}

p {
  margin: 0;
}

ul {
  margin: 0;
  padding: 0;
}

body {
  min-width: 4.2667rem;
  max-width: 750px;
  width: 10rem;
  margin: 0 auto;
  line-height: 1.5;
  font-family: PingFangSC-Regular, sans-serif;
  background: #F2F2F2;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 2.4rem;
  padding-bottom: .4688rem;
  width: 100%;
  padding-top: .7031rem;
  background-color: #fff;
  z-index: 9999999999;
}

.header-l {
  float: left;
  margin-left: .75rem;
  /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
  height: .8rem;
  object-fit: cover;
}

.header-r {
  width: 1.75rem;
  height: 1.375rem;
  float: right;
}

.header-r img {
  width: .62rem;
  height: .5rem;
}

.top-img {
  margin-top: 2.4rem !important;
  padding-top: 8.5rem;
  padding-left: 1.04rem;
  padding-right: 1rem;
  padding-bottom: .4rem;
  //   width: 14rem;
  height: 18.85rem;
  background-size: 100%;
  background-image: url('../../../assets/images/手机端/首页图拷贝.png');
}

.top-img h3 {
  font-weight: 600;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: .72rem;
  margin-left: .5rem;
  margin: 0;
  margin-top: 2.5rem !important;
  color: #23405a;
}

.top-img p {
  text-indent: 2em;
  margin-top: .64rem;
  margin-left: 0;
  font-size: .52rem;
  line-height: .85rem;
  color: #4d5b75;
}

.top-img .button {
  // text-align: center;
  height: 0;
}

.top-img .button button {
  width: 4.6rem;
  height: 1.44rem;
  margin-top: .8rem;
  // border: 1px solid #999 !important;
  /* background-color: rgba(255, 255, 255, 0.1); */
  // background: transparent;
  border: 0px;
  color: #4d5b75;
  font-size: .52rem;
  margin-bottom: .92rem;

  &:hover {
    color: white;
    background: linear-gradient(to right, #2170de, #4f98fe);
  }
}

.main-1 {
  margin-bottom: 1.6rem;
  padding: 0 .3125rem;

}

.main-1 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-1 ul {
  display: flex;
  flex-wrap: wrap;
}

.main-1 ul li img {
  // width: 1rem;
  height: .9rem;
}

.main-1 ul li {
  text-align: center;
  width: 50%;
  /* margin-bottom: .8rem; */
}

.main-1 ul li:nth-child(1),
.main-1 ul li:nth-child(3) {
  margin-bottom: 2rem;
}

.main-1 ul li p {
  color: #2c3e5c;
  margin-top: 26px;
  font-size: .52rem;
}

.gojia {
  /* margin-bottom: 1.5625rem; */
  text-align: center;
  width: 100%;
}

.gojia h3 {
  margin-top: 0px;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: 1.6rem;
}

.gojia img {
  height: 8.8rem;
  width: 12.80rem;
}

.centre {
  padding: 0 .625rem;
}

.centre p {
  margin-top: .625rem;
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  color: #2c3e5c !important;

}

.centre button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  margin-top: .625rem;
  font-size: .52rem;
}

.jiazhi {
  text-align: center;
  padding-top: 1.6rem;
  padding-left: .4375rem;
  padding-right: .4375rem;
}

.jiazhi .cpjiazhi {
  margin: 0;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c;
  font-size: .72rem;
  margin-bottom: .4rem;
}

.jiazhi_rtext {
  width: 10rem;
  height: 3.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.jiazhi_rtext h3 {
  margin: 0 0 .28rem 0;
  font-weight: 400;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c;
  font-size: .56rem;
  text-align: left;
}

.jiazhi ul {
  margin-top: .8rem;
  padding: 0px;
  margin-bottom: 0;

}

.jiazhi ul li {
  text-align-last: left;
  display: flex;
  align-items: center;
  margin-bottom: .5333rem;
  height: 3.5rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.jiazhi p {
  width: 11rem;
  margin-left: 0;
  text-align: left;
  font-size: .52rem;
  color: #4d5b75;
  line-height: .82rem;
  /* margin-bottom: 40px; */
  margin-bottom: 0;
  font-family: PingFangSC-Regular, sans-serif;
}

.jiazhi .jiazhi_limg img {
  width: 1.5rem;
  margin: 0.5rem;
  /* width: 1rem; */
  /* background-color: pink; */
}

.jiazhi button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .375rem;
}

.main-2 {
  margin-top: 1.25rem;
  text-align: center;
  margin-bottom: .625rem;
}

.main-2 h3 {
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
}

.main-2 img {
  margin-bottom: .625rem;
}

.main-2 p {
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  padding: 0 .875rem;
  color: #2c3e5c !important;
}

.main-3 {
  padding: 0 .8438rem;
}

.main-3 ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0px;
}

.main-3 ul li {
  /* float: left; */
  width: 48%;
  height: 3.9844rem;
  background-color: pink;
  margin-bottom: .3125rem;

  /* margin-left: .4688rem; */
}

.main-3 ul li:nth-child(1) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组29.png');
  margin-right: .4688rem;
}

.main-3 ul li:nth-child(2) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组30.png');
}

.main-3 ul li:nth-child(3) {
  margin-right: .4688rem;
  background-image: url('../../../assets/images/手机端/首页 手机端/组32.png');
}

.main-3 ul li:nth-child(4) {
  background-image: url('../../../assets/images/手机端/首页 手机端/组31.png');
}

.main-3 ul li {
  font-size: .375rem;
  font-weight: normal;
}

.main-3 ul li h3 {
  margin-top: .2813rem !important;
  margin-left: .2813rem !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
}

.main-3 ul li h4 {
  margin-top: .2813rem;
}

.main-3 ul li p {
  margin-top: .125rem;

  font-size: .1875rem;
  margin-bottom: .25rem;
}

.main-3 ul li h3,
h4,
p {
  font-weight: normal;
  margin: 0px .2813rem;
  color: #fff;
}

.main-3 ul li p {}

.main-3-botton {
  background-image: url('../../../assets/images/手机端/首页 手机端/组33.png');
  height: 3.9844rem;
}

.main-3-botton h3 {
  font-weight: normal;
  margin-top: 0;
  font-size: .6933rem !important;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #fff;
  margin-left: .2813rem;
  margin-top: .2813rem;
  margin-bottom: 0;
}

.main-3-botton p {
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  font-size: .5625rem;
}

.main-3-botton h4 {
  font-weight: normal;
  font-family: PingFangSC-Regular, sans-serif;
  color: #fff;
  font-size: .5625rem;
}

.main-4 {
  text-align: center;
  margin-top: .625rem;
  /* overflow: hidden; */
  /* padding: 0 .5313rem; */
}

.main-4 button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  font-size: .375rem;
}

.main-4 h3 {
  margin-top: 0;
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
  margin-bottom: .625rem;
}

.main-4 .nav {
  padding: 0 .375rem;
  overflow: hidden !important;
}

.main-4 ul {
  text-align: left;
  /* overflow: hidden; */
  width: 16.875rem;
  height: 7.3438rem;
  background-color: pink;
}

.main-4 ul li {
  float: left;
  margin-right: .3125rem;
  /* width: 60%; */
  height: 7.3438rem;
  background-color: red;
}

.footer {
  position: relative;
  margin-top: 1.6rem;
  padding: 0 .5313rem;
  background-color: #4d73ff;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul li {
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-icon-arrow-right {
  font-size: .56rem;
  margin-right: -0.1rem;
  color: #fff;
}

.footer ul li p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.logn img {
  width: 5.625rem;
  height: 1.5625rem;
  margin-top: .625rem;
  margin-bottom: .625rem;
  /* width: ; */
  /* background-color: pink; */
}

.dianhua img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dianhua p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.dizhi {
  margin-top: .3125rem;
  margin-bottom: .625rem;
}

.dizhi img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dizhi p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.footer-bottom {
  border-top: 1px solid #eee;
  height: 1.4063rem;
}

.footer-bottom {
  padding-top: .3125rem;
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.aaa {
  display: block !important;
  position: fixed;
  top: 0;
  right: 0;
  width: 45%;
  height: 100%;
  background-color: #fff;
  z-index: 9999999999999;
}

.addbtn {
  width: 4.6rem;
  height: 1.44rem;
  background-color: #5d7bff !important;
  /* 不支持线性的时候显示 */
  background-image: linear-gradient(to right, #5d7bff, #7b9cff);
  border-radius: 0.1rem;
  margin-bottom: 1.25rem;
  font-size: .56rem;
  color: #fff !important;
  border: 0;

}

.listiscolor {
  padding: 0 .5625rem;
  padding-top: .3467rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .5333rem;
  height: 4.28rem;
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.mask {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.maskis {
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.listiscolor {
  padding: 0 1.04rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .3125rem;
  background-color: #fff;
  height: 3.5rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.erweima1 {
  display: none;
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
  width: 7.2rem;
  height: 7.2rem;
}

.ismask {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;
}

.isnav {
  position: fixed;
  top: 2.4rem;
  right: 0;
  width: 9rem;
  height: 100%;
  background-color: #fff;

  ul {
    padding: 0 .48rem;

    li {
      height: 2.12rem;
      line-height: 2.12rem;
      color: #2c3e5c;
      font-size: .56rem;
      font-family: Arial, PingFangSC-Semibold, sans-serif;
      border-bottom: 1px solid #eee;
    }

    .subLi {
      padding-left: .58rem;
    }

    li:nth-child(1) {
      border-top: 1px solid #eee;
    }
  }
}

.listiscolor1 {
  // background-color: pink;
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.listiscolor2 {
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.listiscolor3 {
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.listiscolor4 {
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.listiscolor5 {
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.iserweima {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;

  img {
    position: fixed;
    top: calc(50% - 90px);
    left: calc(50% - 90px);
    // width: 7.2rem;
    // height: 7.2rem;
    // left: 50% ;
    // top: 50% ;
    // transform: translate(-50%,-50%);
  }
}

.callUs {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .0);
  animation: callUsBG2 .5s forwards;
}

.callUs_2 {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .3);
  animation: callUsBG1 .5s forwards;
}

.callUs_dialog {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: -50%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs .5s forwards;
}

.callUs_dialog_2 {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: 0%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs1 .5s forwards;
}

.callUs_title {
  position: relative;
  height: 16%;
  // background: #4d73ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;

  .down {
    position: absolute;
    right: .8rem;
    height: .32rem;
  }

  p {
    font-size: .64rem;
    color: #000;
  }
}

.bottom_msg {
  height: 84%;
  padding: 0 .78rem;

  // background: #2c3e5c;
  p {
    margin-top: .6rem;
    font-size: .56rem;
    color: #000;
  }

  input {
    width: 13rem;
    margin-top: .6rem;
    margin-left: .25rem;
    height: 30px;
    font-size: .56rem;
    outline: none;
    border: 0;
    border-bottom: 1px solid #f3f3f3;
  }

  .callUs_btn {
    width: 13rem;
    height: 1.44rem;
    margin-top: 1.2rem;
    margin-left: .25rem;
    background-image: linear-gradient(to right, #5d7bff, #7b9cff);
    border-radius: 0.1rem;
    margin-bottom: 1.25rem;
    font-size: .56rem;
    color: #fff !important;
    border: 0;
  }
}

@keyframes callUs {
  0% {
    bottom: -50%;
  }

  100% {
    bottom: 0%;
  }
}

@keyframes callUs1 {
  0% {
    bottom: 0%;
  }

  100% {
    bottom: -50%;
  }
}

@keyframes callUsBG1 {
  0% {
    background: rgba(0, 0, 0, .3);
  }

  100% {
    background: rgba(0, 0, 0, .0);
  }
}

@keyframes callUsBG2 {
  0% {
    background: rgba(0, 0, 0, .0);
  }

  100% {
    background: rgba(0, 0, 0, .3);
  }
}
</style>
